<template>
  <div class="oldAct">
    <div class="search-input">
      <van-search
        v-model="form.serviceName"
        shape="round"
        placeholder="请输入关键字查询"
        @search="handleSearch"
      />
    </div>
    <div
      :class="
        actNavItem == 'one'
          ? 'nav active1'
          : actNavItem == 'two'
          ? 'nav active2'
          : actNavItem == 'three'
          ? 'nav active3'
          : 'nav'
      "
    >
      <!-- <div class="nav-item">全部</div>
      <div class="nav-item">正在报名</div>
      <div class="nav-item">我参与的</div>-->
      <div
        :class="actNavItem == 'one' ? 'nav-item actNav' : 'nav-item'"
        @click="chageNav('one', '')"
      >
        全部
        <div v-show="actNavItem == 'one'" class="underline"></div>
        <!-- <img src="" alt=""> -->
      </div>
      <div
        :class="actNavItem == 'two' ? 'nav-item actNav' : 'nav-item'"
        @click="chageNav('two', 'apply_ing')"
      >
        正在报名
        <div v-show="actNavItem == 'two'" class="underline"></div>
      </div>
      <div
        :class="actNavItem == 'three' ? 'nav-item actNav' : 'nav-item'"
        @click="chageNav('three', 'completd')"
      >
        我参与的
        <div v-show="actNavItem == 'three'" class="underline"></div>
      </div>
    </div>
    <div class="datalist">
      <div class="datalist-item" v-for="item in actList" :key="item.id" @click="goDetail(item)">
        <img :src="item.filesInfoVo ? item.filesInfoVo[0].imgUrl : ''" alt />
        <div class="text">
          <div class="title">{{ item.serviceName }}</div>
          <div class="time">
            <img src="@/assets/images/Group27.png" alt />
            {{ (item.beginTimePj || "")+`(${item.week || ""})` }}
          </div>
          <div class="apply">
            <!-- 写法一
            <p style="color:#7CA33B" v-if="item.registrationStatus=='已报名'">{{item.registrationStatus}}</p>
            <p style="color:#E05A00" v-if="item.registrationStatus=='正在报名'">{{item.registrationStatus}}</p>
            <p style="color:#666666" v-if="item.registrationStatus=='报名结束' || item.registrationStatus=='报名已满'">{{item.registrationStatus}}</p> -->
            <!-- 写法二 -->
            <p style="color:#E05A00" v-if="item.stopFlag=='Y' && item.countNum!==item.serviceNum">正在报名</p>
            <p style="color:#666666" v-if="item.stopFlag=='N'">报名结束</p>
            <p style="color:#666666" v-if="item.countNum==item.serviceNum  && item.stopFlag=='Y'">报名已满</p>
            <div class="line">
              <div class="total">
                <div ref="have" :style="{width:((item.countNum/item.serviceNum)*100+'%')}" class="have"></div>
              </div>
              <div>{{ item.countNum }}/{{ item.serviceNum }}人报名</div>
            </div>
          </div>
          <!-- 点亮状态 -->
          <div class="button" v-if="item.stopFlag=='Y' && item.countNum!==item.serviceNum" @click.stop="signUp(item)">报名</div>
          <!-- 置灰状态 -->
          <div class="button" style="background: linear-gradient(180deg, #EAEAEA 0%, #D3D3D3 100%);color:#7A7A7A" v-if="item.stopFlag=='N' || item.countNum==item.serviceNum">报名</div>
          <!-- 取消点亮状态 -->
          <div class="button" v-if="actNavItem=='three' && item.stopFlag=='Y'" @click.stop="cancelSignUp(item)">取消</div>
          <!-- 取消置灰状态 -->
          <div class="button" style="background: linear-gradient(180deg, #EAEAEA 0%, #D3D3D3 100%);color:#7A7A7A" v-if="actNavItem=='three' && item.stopFlag=='N'">取消</div>
          <!-- <div
            v-if="item.flag == 'N' && item.stopFlag == 'Y'"
            class="button"
            @click.stop="signUp(item)"
          >报名</div>
          <div v-if="item.flag == 'Y'" class="button" @click.stop="cancelSignUp(item)">取消</div>
          <div
            v-if="
              (item.countNum == item.serviceNum && item.flag=='N') ||
                (item.flag == 'N' && item.stopFlag == 'N')
            "
            class="button"
            style="background: linear-gradient(180deg, #EAEAEA 0%, #D3D3D3 100%);color:#7A7A7A"
          >报名</div>
        </div> -->
        </div>
      </div>
    </div>

    <div class="toast" v-if="isShow">
      请先完善个人信息
      <div class="switch" @click="perfectHandle('personInfo')">去完善</div>
    </div>
  </div>
</template>

<script>
import {
  getSignInfo,
  applySignInfo,
  applySignInfoCancel,
} from "@/api/oldAgeActivity";
import { getIsComplateUserInfo, getUserInfoDetail } from "@/api/user.js";
import { debounce } from "@/utils/index.js";
import { Dialog } from "vant";
import { mapState } from "vuex";
import { Toast } from "vant";
export default {
  name: "User",
  data() {
    return {
      isShow: false,
      actNavItem: "one",
      hasUserInfo: "", //0表示用户信息以完善， 不等于零表示为完善用户信息
      personId: "",
      actList: [],
      imgList: [],
      form: {
        accountDataType:"prod",
        eventStatus: "",
        serviceName: "",
        weixinId: "",
        areaCode:"310101002000",
        startPagination:"N"
      },
    };
  },
  computed: {
    ...mapState("user", ["openId"]),
  },
  methods: {
    handleSearch(val) {
      this.form.serviceName = val;
      this.getData();
    },
    // nav导航切换
    chageNav(val, type) {
      this.actNavItem = val;
      this.form.eventStatus = type;
      if(val=='three' && !window.localStorage.getItem("openId")){
        this.$router.push({
          name: "login",
        });
        return false;
      }
      this.getData();
    },
    // 获取列表数据
    async getData() {
      // console.log(this.form);
      await getSignInfo(this.form).then((res) => {
        if (res.code === 0) {
          this.actList = res.data;
          this.actList.forEach((item, index) => {
            if (item.filesInfoVo) {
              item.filesInfoVo.forEach((ite) => {
                ite.imgUrl = `${process.env.VUE_APP_API_IMGURL}${ite.imgUrl}`;
              });
            }
          });
          // this.$nextTick(() => {
          //   console.log(111111111)
          //   this.actList.forEach((item, index) => {
          //     // 报名占比
          //     this.$refs.have[index].style.width = `${
          //       (item.countNum / item.serviceNum) * 100 + "%"
          //     }`;
          //   });
          //   console.log(this.$refs.have[0].style.width,"width")
          // });
        } else {
          Toast(res.msg)
        }
      });
    },
    // 打开详情
    goDetail(item) {
      this.$router.push({
        path: "oldAgeActivityDetail",
        query: {
          id: item.id,
          weixinId: this.personId,
        },
      });
    },
    // // 防抖函数
    // debounce(fn,num){
    //   let timer=null;
    //   return function(){
    //     if(timer) clearTimeout(timer);
    //     timer=setTimeout(()=>{
    //       fn();
    //     },num)
    //   }
    // },
    // 报名按钮
    signUp(item){
      debounce(this.signUpEd(item),1000)
    },
    // 报名
     async signUpEd(item) {
      // 1.判断是否登录
      if (!window.localStorage.getItem("openId")) {
        this.$router.push({
          name: "login",
        });
        return false;
      }
      // 调用是否完善个人信息接口
      await this.checkUserInfo();
      // 2.判断是否完善个人信息
      if (this.hasUserInfo != "0") {
        // 未完善个人信息
        // console.log(111)
        this.isShow = true;
      } else {
         applySignInfo({
          bizActivityRefId: item.id,
          weixinId: this.personId,
        })
          .then((res) => {
            if (res.code === 0) {
              // 报名成功
              this.getData();
              Toast("活动报名成功");
            } else {
              Toast(res.msg);
            }
          })
          .catch(() => {
            Toast("活动报名失败");
          });
      }
    },
    // 取消报名
    cancelSignUp(item) {
      Dialog.confirm({
        title: "取消报名",
        message: `确认取消参加${item.serviceName}吗?`,
      })
        .then(() => {
          // on confirm
          applySignInfoCancel({
            bizActivityRefId: item.id,
            weixinId: this.personId,
          })
            .then((res) => {
              if (res.code === 0) {
                Toast("取消活动报名成功");
                this.getData();
              } else {
                Toast(res.msg);
              }
            })
            .catch(() => {
              Toast("取消活动报名失败");
            });
        })
        .catch(() => {
          // on cancel
        });
    },

    // 判断用户是否完善个人信息
    async checkUserInfo() {
      const { code } = await getIsComplateUserInfo({
        openId: this.openId,
      });
      this.hasUserInfo = code;
    },

    // 去完善个人信息页面
    perfectHandle(name) {
      this.$router.push(name);
    },

    // 获取个人信息
    async getPerson() {
      if (this.openId) {
        await getUserInfoDetail(this.openId).then((res) => {
          if (res.code === 0 && res.data) {
            this.personId = res.data.id;
            this.form.weixinId = res.data.id;
          }
        });
      }
    },
  },

  async mounted() {
    window.document.title = "活动";
    // this.checkUserInfo();
    await this.getPerson();
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  // margin: 0 auto;
  transform: translate(-50%, -50%);
  width: 225px;
  height: 103px;
  opacity: 1;
  background: #626262;
  border-radius: 8px;
  opacity: 1;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  line-height: 50px;
  .switch {
    width: 77px;
    height: 24px;
    opacity: 1;
    background: #ffd63c;
    border-radius: 12px;
    opacity: 1;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    color: #543302;
    line-height: 24px;
    margin: 0 auto;
    text-align: center;
  }
}
.active1 {
  background: url("../../assets/images/nav2.png") no-repeat 95px 0,
    url("../../assets/images/nav1.png") no-repeat 233px 0;
  background-size: 185px auto;
}
.active2 {
  background: url("../../assets/images/nav4.png") no-repeat 0px 0,
    url("../../assets/images/nav1.png") no-repeat 233px 0;
  background-size: 146px auto;
}
.active3 {
  background: url("../../assets/images/nav4.png") no-repeat 0px 0,
    url("../../assets/images/nav5.png") no-repeat 113px 0;
  background-size: 146px auto;
}
.nav {
  margin: 15px 0;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;
  .nav-item {
    width: 33.33%;
    height: 48px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    color: #7a7a7a;
    line-height: 48px;
    // background: #fff;
    // border-radius: 0px 0 0 5px;
  }
  .navBg {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .actNav {
    color: #ecba00;
  }
  .underline {
    width: 38px;
    height: 3px;
    background-color: #ecba00;
    margin: -7px auto 0;
  }
}
.datalist {
  padding: 20px;
  .datalist-item {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    // justify-content: space-between;
    margin-bottom: 20px;
    > img {
      width: 100px;
      height: 100px;
      margin-right: 20px;
    }
    .text {
      flex-grow: 1;
      height: 100px;
      position: relative;
      .button {
        position: absolute;
        width: 40px;
        height: 24px;
        right: 0;
        top: 0;
        background: linear-gradient(180deg, #ffd63c 0%, #f5c100 100%);
        border-radius: 4px;
        text-align: center;
        line-height: 24px;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        color: #000000;
      }
      .title {
        width: 170px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 21px;
        color: #222222;
        margin-bottom: 10px;
      }
      .time {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        margin-bottom: 8px;
        /* identical to box height, or 150% */
        color: #333333;
        display: flex;
        align-items: center;
        img {
          margin-right: 3px;
        }
      }
      .apply {
        font-style: normal;
        font-weight: 400;
        font-size: 10px;
        line-height: 21px;
        color: #000000;
        p {
          margin: 0;
          padding: 0;
          line-height: 12px;
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 21px;
          color: #e05a00;
        }

        .line {
          display: flex;
          align-items: center;
          .total {
            width: 135px;
            height: 8px;
            background: #fff2c2;
            border-radius: 4px;
            position: relative;
            margin-right: 8px;

            .have {
              position: absolute;
              top: 0;
              left: 0;
              width: 105px;
              height: 8px;
              background: #ffd63c;
              border-radius: 4px;
            }
          }
        }
      }
    }
  }
}
</style>
